@if (tags?.length) {
  <div class="popular-tags">
    <h3 class="popular-tags__heading text-xs fw-500 text-uppercase mb-2">Popular Tags</h3>

    <div class="d-flex flex-wrap gap-2">
      @for (tag of tags | slice:0:10; track tag.tag) {
        <button
          type="button"
          class="popular-tags__chip"
          (click)="select.emit(tag.tag)"
        >
          {{ tag.tag }}&nbsp;<span class="popular-tags__count">{{ formatCount(tag.count) }}</span>
        </button>
      }
    </div>
  </div>
}
